import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit } from 'react-icons/md';
import styles from "./sucursales.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalSucursales from './sucursalesModal';



const customStyles = {
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#046cc2",
            fontSize: "15px",
            color: "white",
        },
    },


};
export default function Sucursales(props) {
    const { windowSize,setMenuActual } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);
    const [codigos, setCodigos] = useState([]);
    const {estados,municipios} = useAuth();

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
        },
        {
            name: 'Sucursarl',
            selector: row => row.description,
        },
        {
            name: 'Estado',
            selector: row => row.stateName,
        },
        {
            name: 'Municipio',
            selector: row => row.municipalityName,
        },
        {
            name: 'Acciones',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setUserEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.description, row.id)}><MdDelete /></button>
                    </div>
                )
            },
        }
    ];

    const handleDelete = (userName, userId) => {
        Swal.fire({
            title: "¿Esta segur@ que desea eliminar la sucursal \"" + userName + "\"?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                let payload = {
                    userName: userName
                }
                api(SERVICE.deleteOfices + `?CentralOfficesId=${userId}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }
    
    const handleUpdate = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        let searchIndexState = estados.findIndex(item => item.value === element.stateId);
                        let stateName = "";
                        if (searchIndexState != -1) {
                            stateName = estados[searchIndexState].label;
                        }
                        let searchIndexMuni = municipios.findIndex(item => item.value === element.municipalityId);
                        let municipalityName = "";

                        if (searchIndexMuni != -1) {
                            municipalityName = municipios[searchIndexMuni].label;
                        }
                        arrayTemp.push({
                            stateName: stateName,
                            municipalityName: municipalityName,
                            ...element
                        });

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    // const handleUpdateRoles = () => {

    //     api(SERVICE.getRoles)
    //         .then((data) => {
    //             let arrayTemp = [];
    //             for (let index = 0; index < data.data.data.length; index++) {
    //                 const element = data.data.data[index];
    //                 arrayTemp.push({
    //                     id: element.id,
    //                     identifier: element.identifier,
    //                     description: element.description
    //                 })
    //             }
    //             setRoles(arrayTemp);
    //         })
    //         .catch((err) => {

    //         })
    // }
    
    useEffect(() => {
        handleUpdate();
    }, [])
    return (
        <>
            <WindowLayout
                title="SUCURSALES"
                route={["Inicio","Catálogos","Sucursales"]}
                actions={[()=>setMenuActual("homeMenu"),()=>setMenuActual("catalogMenu")]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerButtomTop}>
                        <button className='btn btn-sm btn-success' onClick={() => setShowModal(!showModal)}><FaPlus /></button>
                    </div>


                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        persistTableHead
                    />

                </div>
            </WindowLayout>
            <ModalSucursales
                show={showModal}
                setShow={setShowModal}
                roles={roles}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                state={estados}
                municipal={municipios}
                handleUpdate={handleUpdate}
            />
        </>
    );
} 